/**
 * Public-facing jobs API for the marketing site.
 *
 * Lookup is by slug (`/careers/[slug]`) for clean URLs. The `/applications`
 * POST endpoint is public, so applicants don't need an account.
 */

import type { Job, JobApplicationInput, JobFormField, JobStatus } from "@/types";
import api from "./api";

export const jobsService = {
  listJobs: async (status?: JobStatus): Promise<Job[]> => {
    const { data } = await api.get<Job[]>("/jobs", {
      params: status ? { status } : undefined,
    });
    return data;
  },

  getJob: async (id: string): Promise<Job> => {
    const { data } = await api.get<Job>(`/jobs/${id}`);
    return data;
  },

  getJobBySlug: async (slug: string): Promise<Job> => {
    const { data } = await api.get<Job>(`/jobs/by-slug/${slug}`);
    return data;
  },

  listJobFields: async (jobId: string): Promise<JobFormField[]> => {
    const { data } = await api.get<JobFormField[]>(`/jobs/${jobId}/fields`);
    return data;
  },

  submitApplication: async (
    payload: JobApplicationInput,
  ): Promise<{ id: string }> => {
    const { data } = await api.post<{ id: string }>("/applications", payload);
    return data;
  },
};
